<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-body">
        <div class="row">
          <div class="col-md-6">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <td class="text-bold">Date</td>
                  <td>
                    <datepicker
                      :clear-button="true"
                      placeholder="Select Date"
                      @input="getRepairPercentage"
                      v-model="selectedDate"
                      input-class="form-control"
                    >
                    </datepicker>
                  </td>
                  <td class="text-bold text-right">Total</td>
                  <td class="text-right">
                    {{ repairPercentage.total }}
                  </td>
                </tr>
                <tr>
                  <th>Code</th>
                  <th>Reason</th>
                  <th class="text-right">Amount</th>
                  <th class="text-right">Percent</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in repairPercentage.detail"
                  :key="index"
                >
                  <td># {{ pad(data.reason_id) }}</td>
                  <td>{{ data.reason.title_en }}</td>
                  <td class="text-right">{{ data.total }}</td>
                  <td class="text-right">{{ data.percentage }} %</td>
                </tr>
              </tbody>
            </table>

            <div class="grid bg-white mt-50">
              <div class="grid-body p-0 text-center">
                <h4>Repair Shirt Overview on Selected Day</h4>
                <div class="text-center chart-container mt-10">
                  <canvas id="chart"></canvas>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <table class="table table-bordered">
              <tr>
                <td>
                  <datepicker
                    :clear-button="true"
                    placeholder="Select Date"
                    @input="getRepairTimesPercentage"
                    v-model="timesParam.fromDate"
                    input-class="form-control"
                  >
                  </datepicker>
                </td>
                <td>
                  <datepicker
                    :clear-button="true"
                    placeholder="Select Date"
                    @input="getRepairTimesPercentage"
                    v-model="timesParam.toDate"
                    input-class="form-control"
                  >
                  </datepicker>
                </td>
              </tr>
              <tr>
                <th>Times</th>
                <th class="text-right">Percent</th>
              </tr>
              <tr v-for="(data, index) in repairTimesPercentage" :key="index">
                <td>
                  <span v-if="data.times != 4">
                    Shirt Repair {{ data.times }} Times
                  </span>
                  <span v-else> Shirt Repair More Than 4 Times </span>
                </td>
                <td class="text-right">{{ data.percentage }} %</td>
              </tr>
            </table>

            <div class="grid bg-white mt-50">
              <div class="grid-body p-0 text-center">
                <h4>Repair Shirt Overview Between selected Dates</h4>
                <div class="text-center line-chart-container mt-10">
                  <canvas id="lineChart"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import chart from "@/pages/Tools/Chart";

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      repairPercentage: [],
      repairTimesPercentage: [],
      selectedDate: moment().format("YYYY-MM-DD"),
      timesParam: {
        fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
        toDate: moment().format("YYYY-MM-DD"),
      },
      label: [],
      usage: [],
    };
  },
  mounted() {
    this.getRepairPercentage();
    this.getRepairTimesPercentage();
  },
  methods: {
    async getRepairPercentage() {
      let date = moment(this.selectedDate).format("YYYY-MM-DD");

      try {
        let res = await axios.get("shirt_orders/repair/percentage/" + date);
        this.repairPercentage = res.data;
        let temp = this.repairPercentage.detail;
        let label = [];
        let usage = [];
        temp.forEach((val) => {
          label.push("# " + this.pad(val.reason_id));
          usage.push(val.percentage);
        });
        chart.create(label, usage);
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    async getRepairTimesPercentage() {
      try {
        let res = await axios.get("shirt_orders/repair/times/percentage/", {
          params: this.timesParam,
        });
        this.repairTimesPercentage = res.data.times;
        chart.lineChart(res.data.label, res.data.dataSets);
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    pad(number, width = 3, padWith = "0") {
      number = number + "";
      return number.length >= width
        ? number
        : new Array(width - number.length + 1).join(padWith) + number;
    },
  },
};
</script>

<style scoped>
.vdp-datepicker {
  width: 200px !important;
}
.mt-50 {
  margin-top: 50px;
}
</style>
